import { BiSolidUserRectangle } from 'react-icons/bi';
import type { ProductActionsDefinition, ProductSecondaryAction } from '@hopdrive/feature-portal-products';

import type { DashboardButton } from '@utils/embedSettings';

export interface EmbedValetActionKnobs {
  /** The `hiddenButtons` keys the integrator passed. */
  hiddenButtons: readonly DashboardButton[];
  /** `showToolbar`; false withholds every header action. */
  showToolbar: boolean;
  /** The Drivers pages render for this rooftop, so Manage Drivers has a page to open. */
  driversAvailable: boolean;
  /** The bare Drivers path; the query string is added with the other routes. */
  driversPath: string;
}

/** The `hiddenButtons` key that hides each Valet creation method. */
const METHOD_BUTTON: Record<string, DashboardButton> = { plan: 'planMoves', import: 'importMoves' };

const manageDrivers = (to: string): ProductSecondaryAction => ({
  key: 'drivers',
  label: 'Manage Drivers',
  icon: <BiSolidUserRectangle />,
  to,
});

/**
 * Valet's header actions shaped by the integrator's dashboard knobs: `showToolbar` false withholds
 * them all; `hiddenButtons` drops Plan Moves (`planMoves`), Import Moves (`importMoves`), and
 * Manage Drivers (`drivers`), the secondary link offered wherever the Drivers pages render.
 * Undefined when nothing remains.
 */
export function resolveEmbedValetActions(
  definition: ProductActionsDefinition,
  { hiddenButtons, showToolbar, driversAvailable, driversPath }: EmbedValetActionKnobs,
): ProductActionsDefinition | undefined {
  if (!showToolbar) return undefined;
  const hidden = (button: DashboardButton) => hiddenButtons.includes(button);
  const creation = definition.creation.filter(method => !(METHOD_BUTTON[method.key] && hidden(METHOD_BUTTON[method.key])));
  const secondary = driversAvailable && !hidden('drivers') ? manageDrivers(driversPath) : undefined;
  if (creation.length === 0 && !secondary) return undefined;
  return { ...definition, creation, secondary };
}
